import { useEffect, useState } from 'react';
import { findCountryByValue } from './Form/Custom/CustomPhoneInput/helpers';

export const FlagIcon = ({ phone, countryCode, style }: { phone?: string; countryCode?: string; style?: object }) => {
  const [name, setName] = useState<string | undefined>();

  useEffect(() => {
    if (phone) {
      setName(findCountryByValue(phone)?.label);
    }
  }, [phone]);

  useEffect(() => {
    if (countryCode) setName(countryCode);
  }, [countryCode]);

  return name ? (
    <span
      className={`fi fi-${name} fis`}
      style={{
        display: 'inline-block',
        position: 'relative',
        borderRadius: '50%',
        minWidth: '26px',
        minHeight: '26px',
        ...style,
      }}
    />
  ) : null;
};
